import { fetcherCMS } from '@/modules/api';
import { getCMSLocale } from '@/modules/cms';
import { CONTENT_BY_LICENSE_POPULATE } from '@/modules/license/constants';
import type { IWithContentByLicense } from '@/modules/license/helpers';
import { type CMSApiBase, createCmsUrl } from './base';

export interface TermsAndConditionsApi
  extends CMSApiBase,
    IWithContentByLicense {
  title: string;
  titleH1: string;
  effectiveFrom: string;
  lastUpdated: string;
}

export const getTermsAndConditionsUrl = (lang: string) =>
  createCmsUrl({
    path: 'term-and-condition',
    queryData: { ...getCMSLocale(lang), populate: CONTENT_BY_LICENSE_POPULATE },
  });

export const fetchTermsAndConditions = async (lang: string) =>
  fetcherCMS<TermsAndConditionsApi>(getTermsAndConditionsUrl(lang));
